module.exports = __webpack_public_path__ + "img/buy-success.71f36520.png";